/**
 * Validator default. Returns true.
 * 
 * @param {any} value 
 * @returns {boolean} true
 */
export function validate(value) {
    return true;
}


// WEBPACK FOOTER //
// ./src/components/Reservation/Validators/ClientLocator.default.js